module.exports = __webpack_public_path__ + "static/media/view1.dbeecfc1.jpg";